import createSliders from './create-slider.js';

let slider;

function getSliderContainer() {
    return document.querySelector('.js_popupImageSlider');
}

function openSlider(index = 0) {
    const container = getSliderContainer();
    
    if (container && slider) {
        slider.slideTo(index, 0);
        container.classList.add('popupImageSlider--visible');
    }
}

function closeSlider() {
    const container = getSliderContainer();
    
    if (container) {
        container.classList.remove('popupImageSlider--visible');
    }
}

function updateSlideIndex() {
    const slideIndex = document.querySelector('.js_popupImageSlider__slideIndexValue');

    if (slideIndex) {
        slideIndex.innerHTML = slider.activeIndex + 1;
    }
}

function createSlider() {
    const options = {
        slidesPerView: 1,
        watchOverflow: true,
        watchSlidesProgress: true,
        preloadImages: false,
        lazy: true,
    };

    const closeSliderButton = document.querySelector('.js_popupImageSlider__closeButton');

    slider = createSliders('js_popupImageSlider__slider', options)[0];

    if (slider) {
        updateSlideIndex();
        slider.on('slideChange', updateSlideIndex);
    }
    
    if (closeSliderButton) {
        closeSliderButton.addEventListener('click', closeSlider);
    }

    return slider;
}

export { createSlider, openSlider };
